import React from 'react'
import {
    Hero
  } from '../components/organisms'
  import {
      Description, Endsection,
    } from '../components/containers'

function Home() {
    return (
        <>
            <Hero />
            <Description />
            <Endsection />
        </>
    )
}

export default Home
